// ABOUTME: Neutral explanatory note of the bulk change steps: an info icon, a title and a text on a light grey card.
// ABOUTME: Used for guidance that is not a warning (the design's grey info alert), unlike the coloured Alerts.

import { Box, InfoOutlinedIcon, Stack, Typography } from '@ds/coolshop';

type InfoNoteProps = {
    title: string;
    text: string;
};

export function InfoNote({ title, text }: InfoNoteProps) {
    return (
        <Stack direction="row" gap={1.5} px={2} py={1.5} bgcolor="grey.50" borderRadius={2}>
            <Box color="action.active" pt={0.25}>
                <InfoOutlinedIcon fontSize="small" />
            </Box>
            <Stack gap={0.5}>
                <Typography variant="body1">
                    <Box component="span" fontWeight={500}>
                        {title}
                    </Box>
                </Typography>
                <Typography variant="body2">{text}</Typography>
            </Stack>
        </Stack>
    );
}
